import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { TellentAppsEffects } from './store/tellent-apps.effects';
import { TellentAppsNamespace, TellentAppsReducer } from './store/tellent-apps.store';

const provideTellentAppsState = provideState(TellentAppsNamespace, TellentAppsReducer);
const provideTellentAppsEffects = provideEffects(TellentAppsEffects);

export const tellentAppsData = [provideTellentAppsState, provideTellentAppsEffects];
